import { h, createApp } from "vue";
import singleSpaVue from "single-spa-vue";
import Notifications from "@kyvg/vue3-notification";
import singleSpaCss from "single-spa-css";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import Gleap from "gleap";
import bootstrapVue from "bootstrap-vue-next";
import "@/assets/scss/main.scss";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";

const cssConfig = {
  webpackExtractedCss: false,
  shouldUnmount: true,
  timeout: 15000,
  createLink(url) {
    const linkEl = document.createElement("link");
    linkEl.rel = "stylesheet";
    linkEl.href = url;
    return linkEl;
  },
};
if (process.env.NODE_ENV === "production") {
  cssConfig.cssUrls = [
    process.env.VUE_APP_TRANSACTION_APP_URL +
      "/css/app.css?v=" +
      process.env.VUE_APP_CSS_VERSION,
  ];
}
const cssLifecycles = singleSpaCss(cssConfig);

const vueLifecycles = singleSpaVue({
  createApp,
  appOptions: {
    render() {
      return h(App, {});
    },
    mounted() {
      Gleap.initialize(process.env.VUE_APP_GLEAP_KEY);
    },
  },
  handleInstance(app) {
    app.use(createPinia());
    app.use(bootstrapVue({ plugins: { modalController: true } }));
    app.use(Notifications);
    app.use(router);
  },
});
export const bootstrap = [cssLifecycles.bootstrap, vueLifecycles.bootstrap];
export const mount = [cssLifecycles.mount, vueLifecycles.mount];
export const unmount = [vueLifecycles.unmount, cssLifecycles.unmount];

router.beforeEach((to, from, next) => {
  if (
    parseInt(localStorage.getItem("allowTransaction")) === 1 &&
    parseInt(localStorage.getItem("permission")) < 3
  ) {
    next();
  } else {
    window.location.href = "/permission-denied";
  }
});
